"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMetadataObjectXrefEntry = exports.convertMetadataObject = void 0;
// (C) 2019-2021 GoodData Corporation
var api_model_bear_1 = require("@gooddata/api-model-bear");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_backend_base_1 = require("@gooddata/sdk-backend-base");
var supportedMetadataObjectsTypeGuards = [
    api_model_bear_1.GdcMetadata.isAttribute,
    api_model_bear_1.GdcMetadata.isAttributeDisplayForm,
    api_model_bear_1.GdcMetadata.isMetric,
    api_model_bear_1.GdcMetadata.isFact,
    api_model_bear_1.GdcMetadata.isDataSet,
    api_model_bear_1.GdcMetadata.isPrompt,
    api_model_bear_1.GdcMetadata.isTheme,
];
var isSupportedMetadataObject = function (obj) {
    return supportedMetadataObjectsTypeGuards.some(function (isType) { return isType(obj); });
};
exports.convertMetadataObject = function (obj) {
    if (!isSupportedMetadataObject(obj)) {
        throw new sdk_backend_spi_1.UnexpectedError("Cannot convert metadata object, convertor not found! (" + JSON.stringify(obj, null, 4) + ")");
    }
    var ref = sdk_model_1.uriRef(obj.meta.uri);
    var commonModifications = function (builder) {
        return builder
            .title(obj.meta.title)
            .description(obj.meta.summary)
            .id(obj.meta.identifier)
            .production(obj.meta.isProduction === 1)
            .uri(obj.meta.uri);
    };
    if (api_model_bear_1.GdcMetadata.isAttribute(obj)) {
        var attributeDisplayForms_1 = obj.content.displayForms.map(function (displayForm) {
            return sdk_backend_base_1.newAttributeDisplayFormMetadataObject(sdk_model_1.uriRef(displayForm.meta.uri), function (df) {
                return df
                    .attribute(ref)
                    .title(displayForm.meta.title)
                    .description(displayForm.meta.summary)
                    .id(displayForm.meta.identifier)
                    .uri(displayForm.meta.uri)
                    .displayFormType(displayForm.content.type);
            });
        });
        return sdk_backend_base_1.newAttributeMetadataObject(ref, function (a) {
            return a.modify(commonModifications).displayForms(attributeDisplayForms_1);
        });
    }
    else if (api_model_bear_1.GdcMetadata.isAttributeDisplayForm(obj)) {
        return sdk_backend_base_1.newAttributeDisplayFormMetadataObject(ref, function (a) {
            return a
                .modify(commonModifications)
                .attribute(sdk_model_1.uriRef(obj.content.formOf))
                .displayFormType(obj.content.type);
        });
    }
    else if (api_model_bear_1.GdcMetadata.isMetric(obj)) {
        return sdk_backend_base_1.newMeasureMetadataObject(ref, function (m) {
            return m
                .modify(commonModifications)
                .expression(obj.content.expression)
                .format(obj.content.format || "##,#");
        });
    }
    else if (api_model_bear_1.GdcMetadata.isFact(obj)) {
        return sdk_backend_base_1.newFactMetadataObject(ref, function (f) { return f.modify(commonModifications); });
    }
    else if (api_model_bear_1.GdcMetadata.isDataSet(obj)) {
        return sdk_backend_base_1.newDataSetMetadataObject(ref, function (ds) { return ds.modify(commonModifications); });
    }
    else {
        // is prompt
        return sdk_backend_base_1.newVariableMetadataObject(ref, function (v) { return v.modify(commonModifications); });
    }
};
/**
 * Converts xref entry (result of using/usedBy) into IMetadataObject. There's one gotcha: the production indicator
 * is not available in xref entry. Instead of calling out to the backend, this function will hammer in 'true' - which
 * will be right guess in vast majority of cases (hunt me down when this starts causing bugs :)).
 *
 * @param type - specify object type of the xref entry (code ignores the xref category)
 * @param entry - xref entry
 */
exports.convertMetadataObjectXrefEntry = function (type, entry) {
    var ref = sdk_model_1.uriRef(entry.link);
    return {
        type: type,
        uri: entry.link,
        id: entry.identifier,
        ref: ref,
        title: entry.title,
        description: entry.summary,
        production: true,
        unlisted: entry.unlisted === 1,
        deprecated: entry.deprecated === "1",
    };
};
//# sourceMappingURL=MetaConverter.js.map